import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";

import { ApiService } from "./api.service";
import { Profile } from "../models";
import { profileApi } from "../../config";
import { AuthService } from "./auth.service";

@Injectable()
export class ProfileService {
  constructor(
    private apiService: ApiService,
    private authService: AuthService
  ) {}

  getProfile(username: string): Observable<Profile> {
    return this.apiService.get(`${profileApi.getProfile}?username=${username}`);
  }

  getAllRoles() {
    return this.apiService.get(`${profileApi.getAllRoles}`);
  }

  updateProfile(userData) {
    return this.apiService
      .putForAuth(`${profileApi.updateProfile}/${userData.id}`, userData)
      .pipe(
        map((data) => {
          const token = data.headers.get("SR-Authorization");
          this.setAuth(token);
          return data.body;
        })
      );
  }

  setAuth(token: string) {
    // Save token from server in localstorage
    this.authService.setToken(token);
  }

  postProfile(userData) {
    return this.apiService
      .postForAuth(`${profileApi.updateProfile}`, userData)
      .pipe(
        map((data) => {
          const token = data.headers.get("SR-Authorization");
          this.setAuth(token);
          return data.body;
        })
      );
  }

  postProfilePic(profilePic, userId) {
    return this.apiService.postForFile(
      `${profileApi.postProfilePic}/${userId}`,
      profilePic
    );
  }

  getEmailVerify(userId) {
    return this.apiService.get(`${profileApi.getEmailVerify}${userId}`);
  }

  resendApprovalEmail(userId, roleID) {
    return this.apiService.get(
      `${profileApi.resendApprovalEmail}${userId}/role/${roleID}`
    );
  }

  verifyEmail(token) {
    return this.apiService.get(`${profileApi.verifyEmail}${token}`);
  }

  approveUserRole(status, token) {
    return this.apiService.get(
      `${profileApi.approveUserRole}${status}/${token}`
    );
  }

  companyAllUsers(companyId) {
    return this.apiService.get(`${profileApi.companyAllUsers}${companyId}`);
  }

  updatePamProfile(body) {
    return this.apiService
      .postForAuth(`${profileApi.updatePamProfile}`, body)
      .pipe(
        map((data) => {
          const token = data.headers.get("SR-Authorization");
          this.setAuth(token);
          return data.body;
        })
      );
  }
  approveChallenge(req) {
    return this.apiService.post(`${profileApi.approveChallenge}`, req);
  }

  getWelecomePageData(userNm) {
    return this.apiService.get(
      `${profileApi.getpamActivityData}?username=${userNm}`
    );
  }
  updateWelecomePageData(req) {
    return this.apiService.post(`${profileApi.getpamActivityData}?${req}`);
  }
  getDataToken() {
    return this.apiService.get(`${profileApi.getDataToken}`);
  }
  setTokenUserName(action) {
    return this.apiService.post(
      `${profileApi.setTokenUserName}?name=${action}`
    );
  }
  getpamActivityProgress(action) {
    return this.apiService.get(
      `${profileApi.pamActivityProgress}?username=${action}`
    );
  }
  unsubscribeUser(req) {
    return this.apiService.post(`${profileApi.unsubscribeUser}${req}`);
  }
  getEmailNotificationType(id) {
    return this.apiService.get(`${profileApi.emailNotificationType}${id}`);
  }
}
